import React from 'react';

import { Button, Label } from '@tag/tag-components-react-v4';

import { ArrowsContractLined, ArrowsExpandLined, CrossFilled } from '@tag/tag-icons';

import { Header, HeaderTitleWrapper } from '@ui/ModalWithHeader/styled';

import ModalWindow, { IModalWindowProps } from './ModalWindow';

import styles from './modal-window.module.scss';


export interface IAgModalWindowProps extends IModalWindowProps {
  children: any;
  headerIcon?: JSX.Element;
  title?: string;
  maximizeState?: {
    isMaximized: boolean;
    setIsMaximized: React.Dispatch<React.SetStateAction<boolean>>;
  };
}

export default function AgModalWindow(props: IAgModalWindowProps) {
  const { children, headerIcon, title, onClose, maximizeState, ...restProps } = props;

  const changeWindowSize = (maximized: boolean) => {
    maximizeState?.setIsMaximized(maximized);
  };

  return (
    <ModalWindow
      onClose={onClose}
      {...restProps}
    >
      <Header>
        <HeaderTitleWrapper>
          {headerIcon}
          <Label>
            {title}
          </Label>
        </HeaderTitleWrapper>
        <div className={styles['top-right-btn-group']}>
          {maximizeState && 
          <Button 
            className={styles['minimize-maximize-btn']}
            icon={!maximizeState.isMaximized 
              ? <ArrowsExpandLined /> 
              : <ArrowsContractLined /> } 
            onClick={() => changeWindowSize(!maximizeState.isMaximized)} />}
          <CrossFilled onClick={onClose} style={{ cursor: 'pointer' }} />
        </div>
      </Header>
      <div className="pt-15 pr-20 pb-15 pl-20">
        {children}
      </div>
    </ModalWindow>
  );
}
